import { Entity, GenericFieldValue, PagedList, ViewAcl } from '@msdk/definitions'
import React, { createContext, useContext, useState } from 'react'

interface ViewContext {
  isLoading?: boolean
  response?: PagedList | null
  acl?: ViewAcl
  reload?: () => Promise<void>
  fetchData?: () => Promise<void>
  selectedRows?: Entity[]
  currentFilters?: Record<string, GenericFieldValue>
  isInitialized?: boolean
}

interface ContextState {
  context: ViewContext
  update: (ctx: ViewContext) => void
}

const INITIAL_STATE: ContextState = {
  context: {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  update: () => {},
}

const viewContext = createContext<ContextState>(INITIAL_STATE)
export const useViewContext = () => useContext(viewContext)

export function ViewContextProvider({ children }: { children: React.ReactNode }) {
  const [context, setContext] = useState<ViewContext>({ isLoading: true })

  const updateContext = (ctx: ViewContext) => {
    setContext({ ...ctx })
  }

  return <viewContext.Provider value={{ context, update: updateContext }}>{children}</viewContext.Provider>
}
